<template>
    <div class="panel panel-border panel-inverse">
        <div class="panel-heading p-20">
            <img v-if="company.logo_url" class="img-responsive m_0_auto logo_quote" :src="company.logo_url" :alt="company.name">
        </div>
        <div class="panel-body">
            <h4 class="m-t-0 m-b-15 header-title">
                <b>{{ company.fancy_name }}</b>
            </h4>
            <p class="m-b-10"><i class="fa-fw m-r-5 fa fa-envelope-o"></i> <a :href="`mailto:${company.email}`" class="c_default">{{ company.email }}</a></p>
            <p class="m-b-10" if="company.phone"><i class="fa-fw m-r-5 fa fa-phone"></i> {{ company.phone }} </p>
            <p if="company.address"><i class="fa-fw m-r-5 fa fa-map-marker"></i> {{ company.address }}</p>
            <small if="company.complement">{{ company.complement }}</small>
            <p>{{ company.district }} <span if="company.zip_code">- {{ company.zip_code }}</span> <span if="company.city"> - {{ company.city }}</span> <span if="company.state"> - {{ company.state }}</span> <span if="company.country_name"> - {{ company.country_name }}</span></p>
            <div v-if="deal.member_id">
                <hr>
                <h5 class="m-b-15">
                    <i class="fa-fw m-r-5 md-headset-mic"></i> {{ $t('consultant') }} </h5>
                <h5 class="t_uppercase bold">{{ deal.member.full_name }}</h5>
                <p class="m-b-10"><i class="fa-fw m-r-5 fa fa-envelope-o"></i> <a :href="`mailto:${deal.member.email}`" class="c_default">{{ deal.member.email }}</a></p>
                <div class="row">
                    <div class="col-sm-6" v-if="deal.member.phone">
                        <p class="m-b-10"><i class="fa-fw m-r-5 fa fa-phone"></i> {{ deal.member.phone }} </p>
                    </div>
                    <div class="col-sm-6" v-if="deal.member.mobile">
                        <p class="m-b-10"><i class="fa-fw m-r-5 fa fa-mobile"></i> {{ deal.member.mobile }} </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Company',
        props: [ 'company', 'deal' ]
    }
</script>



// WEBPACK FOOTER //
// src/modules/my-quotation/components/Company.vue